module.exports = __webpack_public_path__ + "img/111049.81a8b3e0.png";